"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function WebproxyselectedOutlinedFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#28A745",
    d: "M10.787 0C7.9 0 5.574 2.361 5.574 5.293c0 2.93 2.326 5.292 5.213 5.292S16 8.224 16 5.293C16 2.36 13.674 0 10.787 0zm2.606 4.153l-2.967 3.012a.486.486 0 01-.36.163c-.121 0-.282-.04-.362-.163L8.221 5.66a.522.522 0 010-.733.503.503 0 01.721 0l1.123 1.14 2.567-2.605a.503.503 0 01.721 0c.2.203.241.488.04.692z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2171B5",
    d: "M10.787 11.807a6.143 6.143 0 01-3.088-.815 18.102 18.102 0 00-1.524-.081 20.1 20.1 0 00-1.604.081c-.04-.407-.08-.855-.08-1.343 0-.489.04-.937.08-1.344.2.041.361.041.562.041a6.781 6.781 0 01-.762-3.094c0-.61.08-1.18.24-1.71C1.966 4.316 0 6.758 0 9.69 0 13.15 2.807 16 6.216 16c2.726 0 5.052-1.832 5.894-4.316a6.96 6.96 0 01-1.323.123zm-9.103 0a4.81 4.81 0 01-.481-2.117c0-.774.16-1.466.481-2.117a6.627 6.627 0 001.725.57c-.04.488-.08 1.017-.08 1.547 0 .529.04 1.017.08 1.547a6.629 6.629 0 00-1.725.57zm.602 1.058a5.31 5.31 0 011.283-.407c.16.733.36 1.384.642 1.913-.722-.366-1.404-.854-1.925-1.506zm1.323-5.944c-.481-.122-.922-.244-1.283-.407.521-.651 1.163-1.18 1.925-1.506-.281.57-.482 1.221-.642 1.913zm2.607 7.858c-.482 0-1.083-.937-1.444-2.565.481-.041.962-.082 1.444-.082.48 0 .962.041 1.443.082-.36 1.628-.962 2.565-1.443 2.565zm1.964-.448c.281-.57.482-1.222.642-1.914.481.122.922.245 1.283.448-.48.652-1.163 1.14-1.925 1.466z"
  }));
}

WebproxyselectedOutlinedFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
WebproxyselectedOutlinedFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = WebproxyselectedOutlinedFilled;
exports["default"] = _default;